import {appURLS} from "appRoot/app.constants";
import AdminService from "external-services/diary-admin-service/admin.service";
import DateUtilsService from 'external-services/date-utils-service';

const NS = 'BookingsOverTimeReportService'; // jshint ignore:line

export default function BookingsOverTimeReportService(
  $http, AuthService
) {
  "ngInject";

  var service = {
    getBookingsByDate: getBookingsByDate,
    getBookingsByService: getBookingsByService
  };

  return service;

  function getBookingsByDate(fromDate, toDate) {
    const venue = AdminService.getVenue();
    const venueId = venue.id;
    const requestUrl = appURLS.API + '/restaurants/venues/' + venueId + '/reports/bookings/by-date';
    let data = {
      fromDate: DateUtilsService.dateToIdStr(fromDate),
      toDate: DateUtilsService.dateToIdStr(toDate),
      currentDate: DateUtilsService.dateToIdStr(DateUtilsService.getVenueTime(venue.timeZoneId))
    }

    return $http({
      method: 'GET',
      url: requestUrl + '?fromDate=' + data.fromDate + '&toDate=' + data.toDate + '&currentDate=' + data.currentDate,
      headers: {
        'Authorization': AuthService.getBearerToken()
      }
    });
  }

  function getBookingsByService(fromDate, toDate) {
    const venue = AdminService.getVenue();
    const venueId = venue.id;
    const requestUrl = appURLS.API + '/restaurants/venues/' + venueId + '/reports/bookings/by-service';
    let data = {
      fromDate: DateUtilsService.dateToIdStr(fromDate),
      toDate: DateUtilsService.dateToIdStr(toDate),
      currentDate: DateUtilsService.dateToIdStr(DateUtilsService.getVenueTime(venue.timeZoneId))
    }

    return $http({
      method: 'GET',
      url: requestUrl + '?fromDate=' + data.fromDate + '&toDate=' + data.toDate + '&currentDate=' + data.currentDate,
      headers: {
        'Authorization': AuthService.getBearerToken()
      }
    });
  }
}
